var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiveColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_64",
    "data-name": "Group 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.55,
    height: 47.55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.003,
    x2: 0.5,
    y2: 0.89,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 44.177,
    y1: -10.959,
    x2: 44.177,
    y2: -10.066,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb92e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#dda228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#aa7c1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#7c5b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#563f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#36280a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1e1605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#0d0902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#030200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M-1355.125,349.269a27.5,27.5,0,0,1-27.5,27.5,27.5,27.5,0,0,1-27.5-27.5,27.5,27.5,0,0,1,27.5-27.5A27.5,27.5,0,0,1-1355.125,349.269Z",
    transform: "translate(1410.125 -321.768)",
    fill: "#76cc0e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M-1349.564,337.279c0,6.893-8.218,12.483-18.349,12.483s-18.347-5.589-18.347-12.483,8.215-12.48,18.347-12.48S-1349.564,330.386-1349.564,337.279Z",
    transform: "translate(1395.411 -323.637)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M-1390.409,401.956c0-8.019,8.929-14.523,19.938-14.523s19.939,6.5,19.939,14.523-8.927,14.525-19.939,14.525S-1390.409,409.978-1390.409,401.956Z",
    transform: "translate(1397.969 -362.253)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(5.415 15.126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(6.42 19.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M-1363.942,423.769a16.767,16.767,0,0,1-15.223-9.819,1.065,1.065,0,0,1,.528-1.41,1.065,1.065,0,0,1,1.411.528,14.634,14.634,0,0,0,13.284,8.571,14.637,14.637,0,0,0,13.284-8.571,1.065,1.065,0,0,1,1.411-.528,1.065,1.065,0,0,1,.528,1.41A16.771,16.771,0,0,1-1363.942,423.769Z",
    transform: "translate(1379.261 -412.443)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M-1311.852,372.254a5.891,5.891,0,0,1-5.89,5.892h-7.526a5.89,5.89,0,0,1-5.889-5.892V367.1a5.887,5.887,0,0,1,5.889-5.889h7.526a5.888,5.888,0,0,1,5.89,5.889Z",
    transform: "translate(1356.023 -361.214)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M-1376.7,372.254a5.892,5.892,0,0,1-5.891,5.892h-7.524a5.891,5.891,0,0,1-5.889-5.892V367.1a5.888,5.888,0,0,1,5.889-5.889h7.524a5.889,5.889,0,0,1,5.891,5.889Z",
    transform: "translate(1396.004 -361.214)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 10.799,
    height: 1.637,
    transform: "translate(16.849 3.761)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiveColored);
export default __webpack_public_path__ + "static/media/fiveColored.2ab9ce6c2119e9a5c9b1801c967a0464.svg";
export { ForwardRef as ReactComponent };